<template>
  <b-container fluid class="modificaprofilo">
    <h4>Profilo utente</h4>

    <b-row class="mt-3">
      <b-col sm="6">
        <img v-if="userAvatar" :src="userAvatar" width="150">
        <b-button id="pick-avatar" class="ml-3">
          Cambia immagine<br/>
          <font-awesome-icon icon="image" />
        </b-button>
        <avatar-cropper
          @uploaded="handleUploaded"
          trigger="#pick-avatar"
          :upload-url="getUploadAvatarUrl()"
          withCredentials="true"
          upload-form-name="files"
          mimes="image/png, image/jpeg, image/jpg, image/bmp"
          :labels="{ submit: 'Carica', cancel: 'Annulla' }" />
      </b-col>
      <b-col sm="6" class="p-4">
        <p v-if="profilo.hasCV">Un curriculum è già presente nel tuo profilo, caricandone uno nuovo verrà sovrascitto.</p>
        <b-form-file
          v-model="fileCv"
          size="sm"
          placeholder="Scegli un file o rilascialo qui..."
          drop-placeholder="Rilascia qui il file..."
          accept="application/pdf"></b-form-file>
        <b-button class="mt-3" @click="caricaCv()">
          Carica Curriculum Vitae<br/>
          <font-awesome-icon icon="paperclip" />
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col sm="6" class="text-right">
        <b>Sei un avvocato?</b>
      </b-col>
      <b-col sm="6" class="text-left">
        <b-form-checkbox
          v-model="profilo.avvocato">
            Sì / No
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="mt-5" v-if="!profilo.avvocato">
      <b-col sm="6" class="text-right">
        Titolo abbreviato:
      </b-col>
      <b-col sm="6" class="text-left">
        <b-form-input v-model="profilo.titoloAbbreviato" placeholder="Es: Ing. o Avv."></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mt-5" v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        Ordine di appartenenza:
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-select v-model="profilo.ordineDiAppartenenza" :options="data.ordine" size="sm"></b-form-select>
      </b-col>
      <b-col sm="3" class="text-right">
        Anno di iscrizione nell'ordine:
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input type="number" v-model="profilo.annoIscrizoneOrdine" placeholder="Anno di iscrizione nell'ordine"></b-form-input>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        Abilitazione al patrocinio dinanzi alle Giurisdizioni Superiori:  
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-checkbox
          v-model="profilo.abilitazionePatrocinio">
            Sì / No
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="12" class="text-center my-3">
        <b>Sede principale dello studio</b>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        Via: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedePrincipaleVia" placeholder="Via"></b-form-input>
      </b-col>
      <b-col sm="3" class="text-right">
        Numero civico: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedePrincipaleCivico" placeholder="Numero civico"></b-form-input>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        CAP: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedePrincipaleCap" placeholder="CAP"></b-form-input>
      </b-col>
      <b-col sm="3" class="text-right">
        Città: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedePrincipaleCitta" placeholder="Città"></b-form-input>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        Numero di telefono: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedePrincipaleTelefono" placeholder="Numero di telefono"></b-form-input>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="12" class="text-center my-3">
        <b>Sede secondaria dello studio</b>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        Via: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedeSecondariaVia" placeholder="Via"></b-form-input>
      </b-col>
      <b-col sm="3" class="text-right">
        Numero civico: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedeSecondariaCivico" placeholder="Numero civico"></b-form-input>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        CAP: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedeSecondariaCap" placeholder="CAP"></b-form-input>
      </b-col>
      <b-col sm="3" class="text-right">
        Città: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedeSecondariaCitta" placeholder="Città"></b-form-input>
      </b-col>
    </b-row>
    <b-row v-if="profilo.avvocato">
      <b-col sm="3" class="text-right">
        Numero di telefono: 
      </b-col>
      <b-col sm="3" class="text-left">
        <b-form-input v-model="profilo.sedeSecondariaTelefono" placeholder="Numero di telefono"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" class="text-center my-3">
        <b>Social networks</b>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3" class="text-right">
        Descrizione personale: 
      </b-col>
      <b-col sm="3" class="text-left">
        <vue-editor v-model="profilo.descrizione" :editor-toolbar="customToolbar" ref="editor" placeholder="Descriviti brevemente" />
      </b-col>
      <b-col sm="6">
        <b-row>
          <b-col sm="6" class="text-right">
            Link al profilo Facebook: 
          </b-col>
          <b-col sm="6" class="text-left">
            <b-form-input v-model="profilo.facebook" placeholder="Link al proflo Facebook"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="text-right">
            Link al profilo Twitter: 
          </b-col>
          <b-col sm="6" class="text-left">
            <b-form-input v-model="profilo.twitter" placeholder="Link al proflo Twitter"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="text-right">
            Link al profilo Linkedin: 
          </b-col>
          <b-col sm="6" class="text-left">
            <b-form-input v-model="profilo.linkedin" placeholder="Link al proflo Linkedin"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="text-right">
            Link al tuo sito web: 
          </b-col>
          <b-col sm="6" class="text-left">
            <b-form-input v-model="profilo.sitoWeb" placeholder="Link al tuo sito web"></b-form-input>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" class="text-center mt-3">
        <b-button class="mt-1" variant="outline-success" @click="aggiornaProfilo()">Salva il mio profilo</b-button>
      </b-col>
    </b-row>          
  </b-container>
</template>

<script>
import api from '../../services/service.js'
import ordini from './ordiniDiAppartenenza.js';

import { VueEditor } from "vue2-editor";
import AvatarCropper from "vue-avatar-cropper";

export default {
  name: 'modificaProfilo',
  components: {
    VueEditor,
    AvatarCropper
  },
  data () {
    return {
      profilo: {
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike", { list: "ordered" }, { list: "bullet" }, { color: [] }, { background: [] }]
      ],
      data: {
        ordine: ordini
      },
      userAvatar: '',
      fileCv: null
    }
  },
  methods: {
    handleUploaded(response, form, xhr) {
      this.userAvatar = undefined;
      this.userAvatar = this.getAvatarUrl();
    },
    getAvatarUrl(){
      return api.getBaseUrl() + 'utente/' + this.profilo.codFisc + '/immagine?nocache=' + Math.random();
    },
    getUploadAvatarUrl(){
      return api.getBaseUrl() + 'utente/immagine';
    },
    async getUser(){
      let data = await api.execute('get', 'profilo/me');
      this.profilo = data;
      this.userAvatar = this.getAvatarUrl();
    },
    async aggiornaProfilo(){
      this.profilo.annoIscrizoneOrdine = parseInt(this.profilo.annoIscrizoneOrdine);
      try
      {
        let data = await api.execute('post', 'profilo', this.profilo);
        alert("Profilo salvato con successo!");
      }
      catch(e)
      {
        alert("Errore durante il salvataggio!");
      }
    },
    caricaCv(){
      if(this.fileCv == null || this.fileCv === undefined){
        alert("Selezionare un file PDF da caricare!");
        return;
      }

      let formData = new FormData();

      formData.append("files", this.fileCv);
      api.execute('post', 'utente/cv', formData).then((data) => {
        this.getUser();
        alert("CV caricato con successo!");
      });
    }
  },
  async created() {
    await this.getUser();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Utente/ModificaProfilo.vue